enum EnableReservationsResult {
  successful = 'successful',
  tokenInvalid = 'tokenInvalid',
  hoursRequired = 'hoursRequired',
  failed = 'failed',
}

export default EnableReservationsResult;
